var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_has.js
// module id = 1332
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16